/*
 * @Author: changcheng
 * @LastEditTime: 2023-03-23 17:00:55
 */
import React, { useEffect, FC, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./index.less";
import { RightOutlined } from "@ant-design/icons";
import axios from "@/axios/axios";
import { message } from "antd";
import * as actions from "@/store/actions";

const ProvinceCourse: FC<any> = ({ history, course = {}, setFrom }) => {
  const jump = (data: any) => {
    setFrom({ from: { path: "/index/home", name: "首页" } });
    history.push({ pathname: `/index/subject/${data.id}` });
  };

  // 推荐课程 列表
  // const [recommendList, setRecommendList] = useState([]);
  // const getRecommend = async () => {
  //     const body = {
  //         currentPage: 1,
  //         pageSize: 4
  //     }
  //     const {code, data, msg}: any = await axios.post('shop/front/ce/item/province/list', body);
  //     if(code === 0) {
  //         const continuingEducationCourseList = data && data.continuingEducationCourseList;
  //         setRecommendList(continuingEducationCourseList)
  //     } else {
  //         message.error(msg)
  //     }
  // }

  useEffect(() => {
    console.log(course);
    // getRecommend();
  }, []);
  return (
    <div className={"province-course-module"}>
      <div className={"home-title-bar"}>
        <span className={"title"}>省内项目</span>
        <span className={"more"}></span>
      </div>
      <div className={"province-course-list"}>
        {course &&
          course.map((provice: any, i: number) => (
            <div
              key={i}
              className={"content-course-item"}
              onClick={() => {
                jump(provice);
              }}
            >
              <div className={"item-img"}>
                <img src={provice.imageAllPath} alt="" />
              </div>
              <div className={"item-text"}>
                <div className={"p-box"}>
                  <p>项目负责人：{provice.itemLeaderName}</p>
                  <p>学分：{provice.creditInfo}</p>
                  <p>编号：{provice.itemCode}</p>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default connect((state) => state, actions)(withRouter(ProvinceCourse));
